import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ApiError } from "../types";

const API_URL = import.meta.env.VITE_API_URL;

// Types for Mint Batch
interface TokenAmount {
	tokenId: number;
	amount: number;
}

interface MintBatchDto {
	collectionAddress: string;
	tokenAmounts: TokenAmount[];
}

interface MintDto {
	collectionAddress: string;
	quantity: number;
}

interface MintBatchResponseDto {
	transactionHash: string;
	tokenIds: number[];
	amounts: number[];
}

export const useMintBatchMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<MintBatchResponseDto, ApiError, MintBatchDto>({
		mutationFn: async (data) => {
			const response = await fetch(`${API_URL}/inventory/mint-batch`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});
			toast.success("Batch minted successfully");
		},
		onError: (error) => {
			toast.error(error.message.slice(0, 300));
		},
	});
};

export const useMintNFTMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<MintBatchResponseDto, ApiError, MintDto>({
		mutationFn: async (data) => {
			const response = await fetch(`${API_URL}/inventory/mint`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});

			toast.success("Batch minted successfully");
		},
		onError: (error) => {
			toast.error(error.message.slice(0, 300));
		},
	});
};
